import { HttpErrorResponse } from '@angular/common/http';
import { ApiService } from './../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { QueryParam } from './../query-param';
import { Config } from './../config';
import { Title } from '@angular/platform-browser';
import { Tc } from '../tc';
import { MobileDialogComponent } from '../mobile-dialog/mobile-dialog.component';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-tc',
  templateUrl: './tc.component.html',
  styleUrls: ['./tc.component.css']
})
export class TcComponent implements OnInit {

  mobileNumber: number | undefined;

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private router: Router,
    private titleService: Title,
    private modal: NgbModal
  ) {}
  queryParam!: QueryParam;
  tc!: Tc;

  gameConfig: Config = {} as Config;
  isShow = false;

  ngOnInit() {
    let storageName = this.apiService.getItem();
    this.queryParam = JSON.parse(
      localStorage.getItem(storageName) || 'undefined'
    );

    this.getQueryParam();
    if(this.queryParam.id == "240" || this.queryParam.id == "414"){
      this.queryParam.status = 'ACTIVE';
      this.isShow = true;
    }
    
     // this.getConditionalDialogBox();

    this.getConfigData(this.queryParam.id, this.queryParam.lang, this.queryParam.theme);
    this.getTCData(this.queryParam.id, this.queryParam.lang);
    window.scrollTo(0, document.body.scrollHeight / 2);
  }

  getConfigData(data: any, lang:any, theme: any) {
    this.apiService.getConfigData(data, lang, theme).subscribe(
      (response: any) => {
        this.gameConfig = response;
        this.titleService.setTitle(this.gameConfig.header1);
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }
  getTCData(data: any, lang:any) {
    this.apiService.getTCData(data, lang).subscribe(
      (response: any) => {
        this.tc = response;
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  openDialog(): void {

    const modalRef = this.modal.open(MobileDialogComponent, { size: 'md', backdrop: 'static',  keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }

  getMobileRes(mobileNumber: number, url:any){
    this.apiService.getMobileResponse(url).subscribe(
      (response: any) => {
        console.log('Mobile Reponse ===============', response);
        if(response === true){
          this.mobileNumber = mobileNumber;
          this.queryParam.sub = true;
          this.queryParam.mobileNumber = this.mobileNumber;
          let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
          localStorage.setItem(storageName, JSON.stringify(this.queryParam));        }
          else{
          this.openDialog();
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  getMobilePINRes(mobileNumber: number, pinNumber: number, operatorId: string, url:any){
    this.apiService.getMobilePINResponse(url).subscribe(
      (response: any) => {
        console.log('Mobile Reponse ===============', response);
        if(response !== null){
          this.queryParam.pin = pinNumber;
          this.queryParam.sub = true;
          this.queryParam.mobileNumber = mobileNumber;
          let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
          localStorage.setItem(storageName, JSON.stringify(this.queryParam));        }
          else{
          this.openLoginDialog();
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  openLoginDialog(): void {
    const modalRef = this.modal.open(LoginDialogComponent, { size: 'md', backdrop: 'static',  keyboard: false });
    modalRef.result.then((data) => {
    }, (reason) => {
    });
  }

  getConditionalDialogBox(){    
    if(this.apiService.isRedirct(this.queryParam.id, this.queryParam.biller)){
          if(this.queryParam.msisdn == undefined){
            if(this.queryParam.id == '426'){
              window.location.href = "http://wap.matrixads.in/mglobopay/SMartFrenSSHEGetRequest?serviceId="+1209;
            }else if(this.queryParam.id == '273'){
              window.location.href = "http://wap.matrixads.in/mglobopay/SMartFrenSSHEGetRequest?serviceId="+1212;

            }
          }
    }else if((this.queryParam.id === '298' || this.queryParam.id === '334') && this.queryParam.biller === 'TPAY' && this.queryParam.operator === "8966"){
      if(this.queryParam.mobileNumber === 0){
        this.queryParam.popup = true;
        this.openLoginDialog();
      }else{
        let url = "http://wap.globocom.info/mglobopay/tpayLoginByUsername?msisdn="+this.queryParam.mobileNumber+"&pin="+this.queryParam.pin+"&operatorId="+this.queryParam.operator;
        this.getMobilePINRes(this.queryParam.mobileNumber, this.queryParam.pin, this.queryParam.operator, url)
      }
    }else if((this.queryParam.id == '375') && this.queryParam.biller == "QANAWAT"){
      if(this.queryParam.mobileNumber === 0){
        this.queryParam.popup = true;
        //this.openLoginDialog();
      }else{
        let url = "http://wap.matrixads.in/mglobopay/qanawatKSAPortalValidation/"+this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url);
      }
    }else if(this.queryParam.id === '6' && this.queryParam.biller === 'TPAY' && (this.queryParam.operator === "9071" || this.queryParam.operator === "9073")){
      if(this.queryParam.mobileNumber == 0){
        this.queryParam.popup = true;
        this.openDialog();
      }else{
        let url = "http://wap.matrixads.in/mglobopay/tpaygamesworldPortalValidation/"+this.queryParam.mobileNumber;
        this.getMobileRes(this.queryParam.mobileNumber, url)
      }
    }
  }


  getQueryParam() {
    
    // this.queryParam = {} as QueryParam;
    this.queryParam.theme = 1;
    this.queryParam.popup = false;
    this.queryParam.mobileNumber = 0;
    this.queryParam.sub = false;
    this.activatedRoute.queryParams.subscribe(params => {
      if (typeof params['id'] != undefined && params['id'] != null) {
        this.queryParam.id = params['id'];
      }
      if (typeof params['lang'] != undefined && params['lang'] != null) {
        this.queryParam.lang = params['lang'];
      }

      if (typeof params['code'] != undefined && params['code'] != null) {
        this.queryParam.uuid = params['code'];
      }

      if (
        typeof params['categoryid'] != undefined &&
        params['categoryid'] != null
      ) {
        this.queryParam.categoryid = params['categoryid'];
      }
      if (
        typeof params['operator'] != undefined &&
        params['operator'] != null
      ) {
        this.queryParam.operator = params['operator'];
      }
      if (typeof params['biller'] != undefined && params['biller'] != null) {
        this.queryParam.biller = params['biller'];
      }
      if (typeof params['theme'] != undefined && params['theme'] != null) {
        this.queryParam.theme = params['theme'];
      }
      if (typeof params['msisdn'] != undefined && params['msisdn'] != null) {
        this.queryParam.msisdn = params['msisdn'];
      }
      if (typeof params['country'] != undefined && params['country'] != null) {
        this.queryParam.country = params['country'];
      }
      if (typeof params['cid'] != undefined && params['cid'] != null) {
        this.queryParam.cid = params['cid'];
      }
      if (typeof params['code'] != undefined && params['code'] != null) {
        this.queryParam.code = params['code'];
      }
  

      if (typeof params['msisdn'] != undefined && params['msisdn'] != null) {
        this.queryParam.mobileNumber = params['msisdn'];
      }


      if (typeof params['subscription_id'] != undefined && params['subscription_id'] != null) {
        this.queryParam.subscription_id = params['subscription_id'];
      }

      if (typeof params['operator_name'] != undefined && params['operator_name'] != null) {
        this.queryParam.operator_name = params['operator_name'];
      }


      if (typeof params['service_id'] != undefined && params['service_id'] != null) {
        this.queryParam.serviceId = params['service_id'];
      }

      if (typeof params['serviceid'] != undefined && params['serviceid'] != null) {
        this.queryParam.serviceId = params['serviceid'];
      }

      if (typeof params['serviceId'] != undefined && params['serviceId'] != null) {
        this.queryParam.serviceId = params['serviceId'];
      }

      if (typeof params['serviceName'] != undefined && params['serviceName'] != null) {
        this.queryParam.serviceName = params['serviceName'];
      }
    });
  }

}
